export default "__VITE_ASSET__BoEIPaIJ__"